import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69c2b7f77d947e0014c3b766/weddingpage/src/app/page.tsx");
